import { render, staticRenderFns } from "./VideoUploader.vue?vue&type=template&id=530ba8c2&scoped=true"
import script from "./VideoUploader.vue?vue&type=script&lang=js"
export * from "./VideoUploader.vue?vue&type=script&lang=js"
import style0 from "./VideoUploader.vue?vue&type=style&index=0&id=530ba8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ba8c2",
  null
  
)

export default component.exports